import { Component, OnInit } from '@angular/core';
import { TypeEntretientService } from 'src/app/_services/maintenance-service/type-entretient/type-entretient.service';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotifService } from 'src/app/_services/notif.service';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-type-entretient-add',
  templateUrl: './type-entretient-add.component.html',
  styleUrls: ['./type-entretient-add.component.scss']
})

export class TypeEntretientAddComponent implements OnInit {
  TypeEntretientForm: FormGroup;
  isLoading = false;
  isError = false;
  isSuccess = false;
  isSubmitted = false;
  user;
  isMaterial: boolean = false;

  constructor(
    private TypeEntretientService: TypeEntretientService,
    private notifService: NotifService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private userDialog: MatDialog,
    private ref: MatDialog,
  ) { }

  ngOnInit(): void {
    this.user = this.authService.getUser();

    this.TypeEntretientForm = this.formBuilder.group({
      nom:['',[Validators.required]],
      description:['']   
    });
    this.isMaterial = '/type-entretient/add' != location.pathname;
  }

  get form() {
    return this.TypeEntretientForm.controls;
  }
  
  onSubmit() {
    console.log('on submit');
    this.isSubmitted = true;
    this.isError = false;
    this.isSuccess = false;
    this.isLoading = false;
    

    if (this.TypeEntretientForm.invalid) {
    
      this.translate.get('TypeEntretient.SubmitError')
        .subscribe(val => this.notifService.danger(val));
      return;
    }

    this.isLoading = true;
    const formData = new FormData();
    formData.append('nom', ''+this.form.nom.value);
    formData.append('description', ''+this.form.description.value);
    formData.append('create_id', '' + this.user.id);

      console.log(formData);
      this.TypeEntretientService.post(formData)
      .then(resp => {
        this.translate.get('TypeEntretient.SubmitSuccess')
        .subscribe(val => this.notifService.success(val));
        this.isSubmitted = false;
        this.TypeEntretientForm.reset();
      })
      .catch(err => {
        console.log(err)
        this.translate.get('TypeEntretient.SubmitErrorTypeEntretient')
        .subscribe(val => this.notifService.danger(val));
      })
      .finally(() => this.isLoading = false);
  }
onClose() {
    this.ref.closeAll();
    // location.reload();
  }
}


